(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  const syncFooter = footer => {
    footer.querySelectorAll('.store-footer__group').forEach(group => {
      const summary = group.querySelector('summary');
      if (!summary) return;
      group.open = !mobile.matches;
      summary.tabIndex = mobile.matches ? 0 : -1;
    });
  };

  const syncAll = () => document.querySelectorAll('[data-footer-hybrid]').forEach(syncFooter);
  const onSummaryClick = event => {
    if (!mobile.matches && event.target.closest('.store-footer__group > summary')) event.preventDefault();
  };

  syncAll();
  mobile.addEventListener('change', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('click', onSummaryClick);
})();
